import { HttpStatusCode } from "../lib/HttpStatusCode";
import { SecKy } from "../lib/SecKy";

const endpoint = "/api/reservations";

function getDefaultState() {
  return {
    count: 0,
    data: [], 
    hotels: []
  };
}

const state = getDefaultState();

const actions = {
    reset({ commit }) {
        commit('mReset');
    },
    async getHotels({ commit, rootState, dispatch }) {
        var result = await SecKy.get(endpoint + '/hotels');
        if (!result.success && result.httpStatusCode == HttpStatusCode.UNAUTHORIZED){
            await dispatch("user/reapplyToken", null, { root: true });
            if (!rootState.user.token) {
                console.log(result.error);
                return;
            }
            result = await SecKy.get(endpoint + '/hotels');
        }

        commit('mutate', state => {
            state.hotels.splice(0);
            state.hotels.splice(0, 0, ...result.payload.data);
        })

        return result.payload.data;
    },
    async getReservationBySTResNumber({ commit, rootState, dispatch }, { stResNumber }) {
        var result = await SecKy.get(endpoint + '/by-st-res-number/' + stResNumber);
        if (!result.success && result.httpStatusCode == HttpStatusCode.UNAUTHORIZED){
            await dispatch("user/reapplyToken", null, { root: true });
            if (!rootState.user.token) {
                console.log(result.error);
                return;
            }
            result = await SecKy.get(endpoint + '/by-st-res-number/' + stResNumber);
        }

        commit('mutate', state => {
            state.data.splice(state.data.findIndex(x => x.id === result.payload.id), 1);
        })

        return result.payload;
    }
}

const mutations = {
    mReset(state) {
      Object.assign(state, getDefaultState());
    },
    mutate(state, func) {
        func(state);
    }
} 

export default {
    state,
    getters: {},
    actions,
    mutations,
    namespaced: true
}